import { gql } from "@/services/httpAdapter";

export const onCreateSalesInvoices = gql`
	subscription onCreateSalesInvoices($locationId: String, $commissionCycleId: String) {
		onCreateSalesInvoices(locationId: $locationId, commissionCycleId: $commissionCycleId) {
			locationId
			commissionCycleId
		}
	}
`;
